// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyCSXEkQX_2e0z9oU-taI7q2SYlKFn_JZiA",
  authDomain: "congreso-de-cannabis-medicinal.firebaseapp.com",
  projectId: "congreso-de-cannabis-medicinal",
  storageBucket: "congreso-de-cannabis-medicinal.appspot.com",
  messagingSenderId: "769679070626",
  appId: "1:769679070626:web:e44d3992f23fdb1f8dcefb",
  measurementId: "G-H5Y224WBBX"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/congreso-de-cannabis-medicinal.appspot.com/o/'